<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">商家基本信息</span>
      </div>
      <el-form ref="businessBaseSetting" :model="businessBaseSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主题风格" prop="themeStyle">
              <el-select ref="colorSelect" v-model="businessBaseSetting.themeStyle" clearable placeholder="" @change="colorChange">
                <el-option
                    v-for="item in backgrounds"
                    :key="item"
                    label=""
                    :value="item"
                    v-html="'<div style=background-color:'+ item +';width:' +'100%'+';height:'+'90%'+'></div>'">
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="网站标题" prop="webTitle">
              <el-input v-model="businessBaseSetting.webTitle" placeholder="网站标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家端logo" prop="usertype">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarLogoSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="businessBaseSetting.businessLogo" :src="businessBaseSetting.businessLogo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家端登录背景" prop="usertype">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarBackSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="businessBaseSetting.businessBackImageUrl" :src="businessBaseSetting.businessBackImageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服二维码" prop="usertype">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarQrcodeSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="businessBaseSetting.qrcodeUrl" :src="businessBaseSetting.qrcodeUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服QQ号" prop="qq">
              <el-input v-model="businessBaseSetting.qq" placeholder="客服QQ号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服微信号" prop="wechat">
              <el-input v-model="businessBaseSetting.wechat" placeholder="客服微信号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服电话" prop="telphone">
              <el-input v-model="businessBaseSetting.telphone" placeholder="客服电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家推广链接" prop="businessExtendUrl">
              <el-input v-model="businessBaseSetting.businessExtendUrl" placeholder="商家推广链接"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发任务需要审核" prop="isTaskNeedReview">
              <el-radio-group v-model="businessBaseSetting.isTaskNeedReview" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发任务需要答案" prop="isReleaseTaskQuestion">
              <el-radio-group v-model="businessBaseSetting.isReleaseTaskQuestion" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发任务获取宝贝数据开启淘客接口" prop="isGetDataEnableApi">
              <el-radio-group v-model="businessBaseSetting.isGetDataEnableApi" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="添加店铺开启审核" prop="isAddShopsNeedReview">
              <el-radio-group v-model="businessBaseSetting.isAddShopsNeedReview" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="添加银行卡开启审核" prop="isAddBackcardNeedReview">
              <el-radio-group v-model="businessBaseSetting.isAddBackcardNeedReview" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家佣金账户" prop="isOpenBusinessCommissionAccount">
              <el-radio-group v-model="businessBaseSetting.isOpenBusinessCommissionAccount" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="待审核订单开启提醒" prop="isWaitReviewOrderRemind">
              <el-radio-group v-model="businessBaseSetting.isWaitReviewOrderRemind" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家自主审核超时" prop="businessReviewTimeLimit">
              <el-input v-model="businessBaseSetting.businessReviewTimeLimit" placeholder="输入超时时间"></el-input>
              <span>(单位/分钟,注:如果设置为0，将自动默认30分钟后超时)</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家可绑定店铺个数" prop="businessBindShop">
              <el-input v-model="businessBaseSetting.businessBindShop" placeholder="输入店铺数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="关闭商家注册" prop="isOnOrOffBusinessRegister">
              <el-radio-group v-model="businessBaseSetting.isOnOrOffBusinessRegister" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">业务员基本信息</span>
      </div>
      <el-form ref="b2cSystemSalemanSetting" :model="b2cSystemSalemanSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主题风格" prop="salemanThemeStyle">
              <el-select ref="colorSSelect" v-model="b2cSystemSalemanSetting.salemanThemeStyle" clearable @change="colorSChange">
                <el-option
                    v-for="item in backgrounds"
                    :key="item"
                    label=" "
                    :value="item"
                    v-html="'<div style=background-color:'+ item +';width:' +'100%'+';height:'+'90%'+'></div>'">
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客分享链接文字" prop="customerShareText">
              <el-input type="textarea" v-model="b2cSystemSalemanSetting.customerShareText" placeholder="分享链接文字"></el-input>
              <span>{url}为链接，{code}为分享码</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="每月可提现日" prop="mothCashOutDay">
              <el-input type="textarea" v-model="b2cSystemSalemanSetting.mothCashOutDay" placeholder="每月几号可提现，多日，请用“,”隔开。 "></el-input>
              <span>每月几号可提现，多日，请用“,”隔开。 </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="总站下业务员是否需要审核" prop="isSalemanNeedReview">
              <el-radio-group v-model="b2cSystemSalemanSetting.isSalemanNeedReview" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">试客基本信息</span>
      </div>
      <el-form ref="b2cSystemCustomerSetting" :model="b2cSystemCustomerSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主题风格">
              <el-select ref="colorCSelect" v-model="b2cSystemCustomerSetting.customerThemeStyle" clearable placeholder="" @change="colorCChange">
                <el-option
                    v-for="item in backgrounds"
                    :key="item"
                    label=""
                    :value="item"
                    v-html="'<div style=background-color:'+ item +';width:' +'100%'+';height:'+'90%'+'></div>'">
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="网站标题">
              <el-input v-model="b2cSystemCustomerSetting.customerWebTitle" placeholder="网站标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="站点logo">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarCLogoSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="b2cSystemCustomerSetting.customerLogo" :src="b2cSystemCustomerSetting.customerLogo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="首页滚动图">
          <el-col :span="8">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleB2cAttarchSuccess.bind(null, {index:0})"
                :on-remove="handleAvatarRemove">
              <img v-if="b2cSystemCustomerSetting.firstImageUrl"
                   :src="b2cSystemCustomerSetting.firstImageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-input size="small" v-model="b2cSystemCustomerSetting.firstImageToPath" placeholder="跳转页面路径"></el-input>
          </el-col>
          <el-col :span="8">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleB2cAttarchSuccess.bind(null, {index:1})"
                :on-remove="handleAvatarRemove">
              <img v-if="b2cSystemCustomerSetting.secondImageUrl"
                   :src="b2cSystemCustomerSetting.secondImageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-input size="small" v-model="b2cSystemCustomerSetting.secondImageToPath" placeholder="跳转页面路径"></el-input>
          </el-col>
          <el-col :span="8">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleB2cAttarchSuccess.bind(null, {index:2})"
                :on-remove="handleAvatarRemove">
              <img v-if="b2cSystemCustomerSetting.thirdImageUrl"
                   :src="b2cSystemCustomerSetting.thirdImageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-input size="small" v-model="b2cSystemCustomerSetting.thirdImageToPath" placeholder="跳转页面路径" ></el-input>
          </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服二维码">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarCQrcodeLogoSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="b2cSystemCustomerSetting.customerQrcodeUrl" :src="b2cSystemCustomerSetting.customerQrcodeUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服QQ号">
              <el-input v-model="b2cSystemCustomerSetting.customerQq" placeholder="客服QQ号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服微信号">
              <el-input v-model="b2cSystemCustomerSetting.customerWechat" placeholder="客服微信号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服电话">
              <el-input v-model="b2cSystemCustomerSetting.customerTelphone" placeholder="客服电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分享海报背景图" prop="usertype">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleShareBackImageSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="b2cSystemCustomerSetting.shareBackgroundImageUrl" :src="b2cSystemCustomerSetting.shareBackgroundImageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客分享二维码链接">
              <el-input v-model="b2cSystemCustomerSetting.shareQrcodeUrl" placeholder="试客分享二维码链接"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客分享链接文字">
              <el-input type="textarea" v-model="b2cSystemCustomerSetting.customerSelfShareText" placeholder="分享链接文字"></el-input>
              <span>{url}为链接，{code}为分享码</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="添加淘宝号提示文字">
              <el-input v-model="b2cSystemCustomerSetting.promptWithAddTaoText" placeholder="添加淘宝号提示文字"></el-input>
              <span>添加淘宝号提示文字</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客端url地址">
              <el-input v-model="b2cSystemCustomerSetting.customerClientUrl" placeholder="请输入url地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客欢迎语">
              <el-input v-model="b2cSystemCustomerSetting.customerWelcomeText" placeholder="请输入试客欢迎语"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证验证才能做单">
              <el-radio-group v-model="b2cSystemCustomerSetting.isVerfiyIdcardMakeOrder" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客收款是否需要支付宝">
              <el-radio-group v-model="b2cSystemCustomerSetting.isReciveUseAlipay" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联网核对码">
              <el-input v-model="b2cSystemCustomerSetting.netConnectNumber" placeholder="联网核对码"></el-input>
              <span>联网核验APPCODE</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联网核验">
              <el-select v-model="b2cSystemCustomerSetting.netContentContext" clearable placeholder="请选择联网核验">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="关闭试客注册">
              <el-radio-group v-model="b2cSystemCustomerSetting.isCustomerNeedReview" @change="tackReviewChange">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工作时间">
              <el-input v-model="b2cSystemCustomerSetting.workTime" placeholder="请输入工作时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">配置试客端的提示文字</span>
      </div>
      <el-form ref="b2cSystemOrderSetting" :model="b2cSystemCustomerSetting" label-width="260px">
      <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="充值中心的提示文字">
              <el-input type="textarea" v-model="b2cSystemCustomerSetting.chargeMoneyQrunderText" placeholder="充值中心的提示文字"></el-input>
              <span>充值中心的提示文字</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分享收益提示文字">
              <el-input type="textarea" v-model="b2cSystemCustomerSetting.shareCodeTitleText" placeholder="分享收益提示文字"></el-input>
              <span>分享收益提示文字</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">订单配置</span>
      </div>
      <el-form ref="b2cSystemOrderSetting" :model="b2cSystemOrderSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="业务员是否多级抽佣">
              <el-radio-group v-model="b2cSystemOrderSetting.isSalemanMoreCommission" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客超时或者手动取消订单回池">
              <el-radio-group v-model="b2cSystemOrderSetting.isCustomerReturnOrCancelOrder" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="买手取消次数">
              <el-input v-model="b2cSystemOrderSetting.customerCancelNumbers" placeholder="999999"></el-input>
              <span> 0为默认回池，买手取消次数达到直接取消订单 </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发货超时时间(分钟)">
              <!--刷单里是订单超时时间-->
              <el-input v-model="b2cSystemOrderSetting.orderTimeLimit" placeholder="请输入超时时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="租号养号时间(分钟)">
              <el-input v-model="b2cSystemOrderSetting.rentNumberTimeLimit" placeholder="租号养号时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- <el-form-item label="核验店铺超时时间(分钟)"> -->
              <el-form-item label="审核超时时间(分钟)">
              <el-input v-model="b2cSystemOrderSetting.verifyShopTimeLimit" placeholder="请输入超时时间"></el-input>
              <span> (分钟) (申诉审核，退款审核超时时间) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="浏览订单任务详情超时时间">
              <el-input v-model="b2cSystemOrderSetting.browseOrderDetailTimeLimit" placeholder="请输入超时时间"></el-input>
              <span> (分钟) (试客接单后多久没浏览订单任务详情自动放弃订单) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提交订单时间限制">
              <el-input v-model="b2cSystemOrderSetting.commitOrderTimeLimit" placeholder="请输入超时时间"></el-input>
              <span> (分钟) (试客核验店铺成功后多久才可以操作下单并提交订单号) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="限制试客提交订单金额">
              <el-input v-model="b2cSystemOrderSetting.customerOrderMoneyLimit" placeholder="请输入金额"></el-input>
              <span> (试客实付金额允许高于本金多少) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="货返截点金额">
              <el-input v-model="b2cSystemOrderSetting.cargoReturnMoney" placeholder="请输入金额"></el-input>
              <span> (立返<=截点金额＆lt;货返。当值为-1时,货返/立返商家可自行选择) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="商返订单是否审核">
              <el-radio-group v-model="b2cSystemOrderSetting.isBusinessReturnNeedReview" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="不允许发放商返订单平台">
               <el-checkbox-group v-model="b2cSystemOrderSetting.canNotReleaseBusinessOrderPlatefromAry">
                  <el-checkbox label="淘宝"></el-checkbox>
                  <el-checkbox label="京东"></el-checkbox>
                  <el-checkbox label="拼多多"></el-checkbox>
                  <el-checkbox label="抖音"></el-checkbox>
                  <el-checkbox label="阿里巴巴"></el-checkbox>
                  </el-checkbox-group>
              <span>（勾选之后所属对应类型不允许发放商返订单） </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家自动确认发货(小时)">
              <el-input v-model="b2cSystemOrderSetting.businessAutoSendCargoTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="普通任务商家自动确认发货延长时(小时)">
              <el-input v-model="b2cSystemOrderSetting.taskBusinessAutoConfirmExtenTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家待返款订单超时时间(小时)">
              <el-input v-model="b2cSystemOrderSetting.businessWaitReturnMoneyLimit" placeholder="请输入时间"></el-input>
              <span>小时(设置为0则不判断,超时时间从买手提交订单号后隔天0点算起) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家自动确认好评(小时)">
              <el-input v-model="b2cSystemOrderSetting.businessAutoConfirmGoodReviewTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家自动确认追评(小时)">
              <el-input v-model="b2cSystemOrderSetting.businessAutoConfirmGoodResetviewTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">短信配置</span>
      </div>
      <el-form ref="b2cSystemSmsSetting" :model="b2cSystemSmsSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="短信倒计时时长(单位/秒)" prop="smsRecountTime">
              <el-input v-model="b2cSystemSmsSetting.smsRecountTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="短信验证码过期时间(单位/秒)" prop="smsVerifyCodeInvalidTime">
              <el-input v-model="b2cSystemSmsSetting.smsVerifyCodeInvalidTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">银行卡信息</span>
      </div>
      <el-form ref="b2cSystemBackCardSetting" :model="b2cSystemBackCardSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户行" prop="backName">
              <el-input v-model="b2cSystemBackCardSetting.backName" placeholder="请输入开户行"></el-input>
              <span> (建设银行 泉州市田安路支行) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款人" prop="backCardName">
              <el-input v-model="b2cSystemBackCardSetting.backCardName" placeholder="请输入收款人"></el-input>
              <span> (******) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="充值地址" prop="backCardNum">
              <el-input v-model="b2cSystemBackCardSetting.backCardNum" placeholder="请输入收款人"></el-input>
              <span>  (6217 0018 3001 ******)  </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">提现</span>
      </div>
      <el-form ref="b2cSystemCashOutSetting" :model="b2cSystemCashOutSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现控制(单位/元)" prop="cashOutLimit">
              <el-input v-model="b2cSystemCashOutSetting.cashOutLimit" placeholder="请输入提现限制金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现提示语" prop="cashOutCustomerRemindText">
              <el-input v-model="b2cSystemCashOutSetting.cashOutCustomerRemindText" placeholder="请输入提示语"></el-input>
              <span> (提现试客前段提现注意)  </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现提示语" prop="cashOutBusinessRemindText">
              <el-input v-model="b2cSystemCashOutSetting.cashOutBusinessRemindText" placeholder="请输入提示语"></el-input>
              <span>（提现商家前段提现注意)  </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现限制催评数量(单)" prop="cashOutReviewNumberLimit">
              <el-input v-model="b2cSystemCashOutSetting.cashOutReviewNumberLimit" placeholder="请输入数量" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="限制申请提现" prop="isCashOutLimit">
              <el-radio-group v-model="b2cSystemCashOutSetting.isCashOutLimit" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <span>（注：每天限制提现一次） </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="8">
              <el-form-item label="用户提现低于">
                <el-input v-model="b2cSystemCashOutSetting.cashOutLtMonty" placeholder="请输入金额" disabled></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="2.5"><span style="line-height: 40px;">元需要间隔</span></el-col>
          <el-col :span="4">
            <el-input v-model="b2cSystemCashOutSetting.cashOutRangeDay" placeholder="请输入天数" disabled></el-input>
          </el-col>
          <el-col :span="2.5"><span style="line-height: 40px;">天，方可再次提现。</span></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提现手续费：" prop="accountMoneyStoreRate">
              <el-input v-model="b2cSystemCashOutSetting.accountMoneyStoreRate" placeholder="请输入费用" >
              <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="支付密码设置" prop="isOpenPayPassword">
              <el-radio-group v-model="b2cSystemCashOutSetting.isOpenPayPassword" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <div>（注：取现，添加收款账号是否验证支付密码）</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">验号配置</span>
      </div>
      <el-form ref="b2cSystemVerifyPhoneSetting" :model="b2cSystemVerifyPhoneSetting" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="验号类型" prop="verifyPhoneType">
              <el-radio-group v-model="b2cSystemVerifyPhoneSetting.verifyPhoneType" @change="tackReviewChange">
                <el-radio :label="1">畅行</el-radio>
                <el-radio :label="0">小爱</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="增值服务AppKey" prop="appKey">
              <el-input v-model="b2cSystemVerifyPhoneSetting.appKey" placeholder="请输入AppKey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="增值服务AppSecret" prop="appSecret">
              <el-input v-model="b2cSystemVerifyPhoneSetting.appSecret" placeholder="请输入AppSecret"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="畅行验号Url" prop="verifyUrl">
              <el-input v-model="b2cSystemVerifyPhoneSetting.verifyUrl" placeholder="请输入Url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="畅行验号密钥" prop="appPm2">
              <el-input v-model="b2cSystemVerifyPhoneSetting.appPm2" placeholder="请输入密钥"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">订单结算配置</span>
      </div>
      <el-form ref="b2cSystemSettleAccountsLimit" :model="b2cSystemSettleAccountsLimit" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号重新审核天数" prop="accountResetReviewDays">
              <el-input v-model="b2cSystemSettleAccountsLimit.accountResetReviewDays" placeholder="请输入天数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="本金返还延长时间(小时)" prop="moneyReturnExtenTime">
              <el-input v-model="b2cSystemSettleAccountsLimit.moneyReturnExtenTime" placeholder="请输入小时"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="佣金返还延长时间(小时)" prop="commissionReturnExtenTime">
              <el-input v-model="b2cSystemSettleAccountsLimit.commissionReturnExtenTime" placeholder="请输入小时"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="业务员抽佣方式" prop="salemanCommissionType">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.salemanCommissionType" @change="tackReviewChange">
                <el-radio :label="1">按百分比</el-radio>
                <el-radio :label="0">固定金额</el-radio>
                <el-radio :label="2">固定金额+百分比</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="业务员抽佣基数" prop="salemanCommissionBaseMoney">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.salemanCommissionBaseMoney" @change="tackReviewChange">
                <el-radio :label="1">服务费扣佣金</el-radio>
                <el-radio :label="0">服务费</el-radio>
                <el-radio :label="2" disabled>服务费扣固定金额</el-radio>
                <el-radio :label="3" disabled>服务费扣平台显示服务费</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="业务员抽佣基数扣减固定金额" prop="salemanCommissionFixMoney">
              <el-input v-model="b2cSystemSettleAccountsLimit.salemanCommissionFixMoney" placeholder="请输入金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家推荐抽佣比例" prop="businessRecommendRate">
              <el-input v-model="b2cSystemSettleAccountsLimit.businessRecommendRate" placeholder="请输入比例"><i slot="suffix">%</i></el-input>
              <span> (服务费比例) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="本金平台返款手续费收取" prop="moneyReturnBrokerageType">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.moneyReturnBrokerageType" @change="tackReviewChange">
                <el-radio :label="1">按百分比</el-radio>
                <el-radio :label="0">固定金额</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="本金平台返款手续费比例" prop="moneyReturnBrokerageMoneyRate">
              <el-input v-model="b2cSystemSettleAccountsLimit.moneyReturnBrokerageMoneyRate" placeholder="请输入比例"><i slot="suffix">%</i></el-input>
              <span> (本金比例) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="本金平台返款手续费" prop="moneyReturnBrokerageMoney">
              <el-input v-model="b2cSystemSettleAccountsLimit.moneyReturnBrokerageMoney" placeholder="请输入金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="本金平台返款手续费分站抽佣" prop="moneyReturnBrokerageRate">
              <el-input v-model="b2cSystemSettleAccountsLimit.moneyReturnBrokerageRate" placeholder="请输入比例"><i slot="suffix">%</i></el-input>
              <span> (手续费比例) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="佣金返还时间类型" prop="brkerageReturnTimeType">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.brkerageReturnTimeType" @change="tackReviewChange">
                <el-radio :label="1">商家确认评价</el-radio>
                <el-radio :label="0">商家确认发货</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="淘宝号上传图片" prop="taobaoUploadImageTypeAry">
              <el-checkbox-group v-model="b2cSystemSettleAccountsLimit.taobaoUploadImageTypeAry">
                <el-checkbox label="个人中心截图"></el-checkbox>
                <el-checkbox label="订单中心截图"></el-checkbox>
                <el-checkbox label="会员名截图"></el-checkbox>
                <el-checkbox label="支付宝个人信息"></el-checkbox>
                <el-checkbox label="淘气值截图"></el-checkbox>
                <el-checkbox label="我的评价截图"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="京东号上传图片" prop="jdUploadImageTypeAry">
              <el-checkbox-group v-model="b2cSystemSettleAccountsLimit.jdUploadImageTypeAry">
                <el-checkbox label="个人中心截图"></el-checkbox>
                <el-checkbox label="订单中心截图"></el-checkbox>
                <el-checkbox label="会员名截图"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="拼多多上传图片" prop="pddUploadImageTypeAry">
              <el-checkbox-group v-model="b2cSystemSettleAccountsLimit.pddUploadImageTypeAry">
                <el-checkbox label="个人中心截图"></el-checkbox>
                <el-checkbox label="订单中心截图"></el-checkbox>
                <el-checkbox label="微信号截图"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="抖音号上传图片" prop="dyUploadImageTypeAry">
              <el-checkbox-group v-model="b2cSystemSettleAccountsLimit.dyUploadImageTypeAry">
                <el-checkbox label="抖音账号截图"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="试客验证条件" prop="customerVerifyConditionAry">
              <el-checkbox-group v-model="b2cSystemSettleAccountsLimit.customerVerifyConditionAry">
                <el-checkbox label="手持身份证" checked></el-checkbox>
                <el-checkbox label="身份证正面" checked></el-checkbox>
                <el-checkbox label="身份证反面" checked></el-checkbox>
                <el-checkbox label="开户银行"></el-checkbox>
                <el-checkbox label="支付宝账号"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客完成单才能分享" prop="customerFinishOrderShareNumbers">
              <el-input v-model="b2cSystemSettleAccountsLimit.customerFinishOrderShareNumbers" placeholder="请输入单数"><i slot="suffix">%</i></el-input>
              <span>(单:完成几单才可以分享) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="新手订单收货结算" prop="newCustomerOrderReciveConculate">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.newCustomerOrderReciveConculate" @change="tackReviewChange">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="商家日报表是否开启结存模式" prop="businessDayReportOnJiecMode">
              <el-radio-group v-model="b2cSystemSettleAccountsLimit.businessDayReportOnJiecMode" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">接单限制</span>
      </div>
      <el-form ref="reciveOrderLimit" :model="reciveOrderLimit" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客未接单自动回池时间(秒)" prop="rebackTime">
              <el-input type="number" v-model="reciveOrderLimit.rebackTime" placeholder="请输入秒"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客重复接相同订单间隔(秒)" prop="orderRepeatTime">
              <el-input type="number" v-model="reciveOrderLimit.orderRepeatTime" placeholder="请输入秒"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="新手前几单接单限制单数(单)" prop="newOrderLimit">
              <el-input type="number" v-model="reciveOrderLimit.newOrderLimit" placeholder="请输入单数"></el-input>
              <span> (试客做单前几单) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="14">
            <el-form-item label="新手前几单接单限制金额(元)" prop="newOrderMoney">
              <el-input type="number" v-model="reciveOrderLimit.newOrderMoney" placeholder="请输入金额"></el-input>
              <span> (只能接小于该值,注:该值为每单的订单发布价格) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客类目限制(天)" prop="typeDayLimit">
              <el-input type="number" v-model="reciveOrderLimit.typeDayLimit" placeholder="请输入单数"></el-input>
              <span> (每个账号接同类目间隔天数) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客接单限制(秒)" prop="customerOrderLimit">
              <el-input type="number" v-model="reciveOrderLimit.customerOrderLimit" placeholder="请输入单数"></el-input>
              <span> (试客端点击接单的频率,建议10秒+)) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="不限制接单数" prop="orderNotLimit">
              <el-checkbox-group v-model="reciveOrderLimit.orderNotLimitAry">
                <el-checkbox label="淘宝"></el-checkbox>
                <el-checkbox label="京东" checked></el-checkbox>
                <el-checkbox label="拼多多" checked></el-checkbox>
                <el-checkbox label="抖音" checked></el-checkbox>
                <el-checkbox label="阿里巴巴"></el-checkbox>
              </el-checkbox-group>
              <span>（勾选之后每天接单,试客进行中单数限制,试客操作中单数限制,试客催评中单数限制将不会进行限制）</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="不需要试客账号复审" prop="accountNotReview">
              <el-checkbox-group v-model="reciveOrderLimit.accountNotReviewAry">
                <el-checkbox label="淘宝"></el-checkbox>
                <el-checkbox label="京东" checked></el-checkbox>
                <el-checkbox label="拼多多" checked></el-checkbox>
                <el-checkbox label="抖音" checked></el-checkbox>
                <el-checkbox label="阿里巴巴"></el-checkbox>
              </el-checkbox-group>
              <span>（勾选之后所属平台试客账号将无需复审）</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="每天接单(单)" prop="orderNumbersToday">
              <el-input type="number" v-model="reciveOrderLimit.orderNumbersToday" placeholder="请输入单数"></el-input>
              <span> (每个账号每天最多) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="每天平台账户接单">
              <div>
                淘宝<el-input type="number" v-model="reciveOrderLimit.taoOrdersLimit" placeholder="请输入单数"></el-input>
                京东<el-input type="number" v-model="reciveOrderLimit.jdOrdersLimit" placeholder="请输入单数"></el-input>
                抖音<el-input type="number" v-model="reciveOrderLimit.dyOrdersLimit" placeholder="请输入单数"></el-input>
                拼多多<el-input type="number" v-model="reciveOrderLimit.pddOrdersLimit" placeholder="请输入单数"></el-input>
                阿里巴巴<el-input type="number" v-model="reciveOrderLimit.albabaOrdersLimit" placeholder="请输入单数"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客进行中单数限制(单)" prop="loadingOrdersLimit">
              <el-input type="number" v-model="reciveOrderLimit.loadingOrdersLimit" placeholder="请输入单数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客操作中单数限制(单)" prop="opertionOrdersLimit">
              <el-input type="number" v-model="reciveOrderLimit.opertionOrdersLimit" placeholder="请输入单数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客催评中单数限制(单)" prop="reviewOrdersLimit">
              <el-input type="number" v-model="reciveOrderLimit.reviewOrdersLimit" placeholder="请输入单数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="确认发货间隔评价时间(小时)" prop="spaceReviewTime">
              <el-input type="number" v-model="reciveOrderLimit.spaceReviewTime" placeholder="请输入时间"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="8">
            <el-form-item label="同一号(平台账号)">
              <el-input type="number" v-model="reciveOrderLimit.plateformCommonDay" placeholder="请输入天数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2.5"><span style="line-height: 40px;">天内不能超过</span></el-col>
          <el-col :span="4">
            <el-input type="number" v-model="reciveOrderLimit.plateformCommitLimit" placeholder="请输入单数"></el-input>
          </el-col>
          <el-col :span="2.5"><span style="line-height: 40px;">单。</span></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="复购天数(天)" prop="repurchaseDay">
              <el-input type="number" v-model="reciveOrderLimit.repurchaseDay" placeholder="请输入天数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="是否按帐号复购" prop="isAccountRepurchase">
              <el-radio-group v-model="reciveOrderLimit.isAccountRepurchase" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <span> (是:按照试客的平台帐号限制复购，否:按照试客帐号限制复购) </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客淘宝平台账号数" prop="plateformAccountTaoLimit">
              <el-input type="number" v-model="reciveOrderLimit.plateformAccountTaoLimit" placeholder="请输入账号数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客京东平台账号数" prop="plateformAccountJdLimit">
              <el-input type="number" v-model="reciveOrderLimit.plateformAccountJdLimit" placeholder="请输入账号数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客拼多多平台账号数" prop="plateformAccountPddLimit">
              <el-input type="number" v-model="reciveOrderLimit.plateformAccountPddLimit" placeholder="请输入账号数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客抖音平台账号数" prop="plateformAccountDyLimit">
              <el-input type="number" v-model="reciveOrderLimit.plateformAccountDyLimit" placeholder="请输入账号数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="试客阿里巴巴平台账号数" prop="plateformAccountAlbabaLimit">
              <el-input type="number" v-model="reciveOrderLimit.plateformAccountAlbabaLimit" placeholder="请输入账号数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="申诉中继续结算" prop="isAppealContinueBalance">
              <el-radio-group v-model="reciveOrderLimit.isAppealContinueBalance" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="是否关闭淘宝核验" prop="isTurnoffTaoVerify">
              <el-radio-group v-model="reciveOrderLimit.isTurnoffTaoVerify" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="强制淘宝核验" prop="isForceVerfy">
              <el-radio-group v-model="reciveOrderLimit.isForceVerfy" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="浏览单试客账号限制" prop="isBrowseCustomerLimit">
              <el-radio-group v-model="reciveOrderLimit.isBrowseCustomerLimit" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="任务操作页店铺名称提示显示位置">
              <el-checkbox-group v-model="reciveOrderLimit.shopNameShowPositionAry">
                <el-checkbox label="1"></el-checkbox>
                <el-checkbox label="2" checked></el-checkbox>
                <el-checkbox label="3" checked></el-checkbox>
                <el-checkbox label="4" checked></el-checkbox>
                <el-checkbox label="5"></el-checkbox>
                <el-checkbox label="6"></el-checkbox>
                <el-checkbox label="7" ></el-checkbox>
                <el-checkbox label="8" ></el-checkbox>
                <el-checkbox label="9" ></el-checkbox>
                <el-checkbox label="10"></el-checkbox>
                <el-checkbox label="11"></el-checkbox>
                <el-checkbox label="12" ></el-checkbox>
                <el-checkbox label="13" ></el-checkbox>
                <el-checkbox label="14" ></el-checkbox>
                <el-checkbox label="15"></el-checkbox>
                <el-checkbox label="最后一位"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="强制绑定账号" prop="needBindPlateform">
              <el-radio-group v-model="reciveOrderLimit.needBindPlateform" @change="tackReviewChange">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="reciveOrderLimit.needBindPlateform">
          <el-col :span="24">
            <el-form-item label="强制绑定账号平台" prop="accountNeedToBindAry">
              <el-checkbox-group v-model="reciveOrderLimit.accountNeedToBindAry">
                <el-checkbox label="淘宝"></el-checkbox>
                <el-checkbox label="京东" ></el-checkbox>
                <el-checkbox label="拼多多" ></el-checkbox>
                <el-checkbox label="抖音" ></el-checkbox>
              </el-checkbox-group>
              <span>（勾选所属平台之后试客必须绑定平台账号后才能接单）</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-row :gutter="30" style="text-align: center">
        <el-col :span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col :span="10" style="text-align: left">
        <el-button type="primary" icon="el-icon-folder" @click="saveData">保存</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {
  addOrUpdateBackCardSetting,
  addOrUpdateBusinessSetting, addOrUpdateCashOutSetting,
  addOrUpdateCustomerSetting,
  addOrUpdateOrderSetting,
  addOrUpdateSalemanSetting, addOrUpdateSettletSetting,
  addOrUpdateSmsSetting, addOrUpdateVerifyPhoneSetting,
  addReplaceOrderLimit,
  getAllOrderLimit, queryBackCardSetting,
  queryBusinessSetting, queryCashOutSetting,
  queryCustomeSetting,
  queryOrderSetting,
  querySalemanSetting, querySettletSetting, querySmsSetting, queryVerifyPhoneSetting
} from "../../api/b2cbusiness/b2c_websetting";
import {getJwtToken} from "../../lib/utils";
export default {
  name: "TaskManagelist",
  mixins:[MixinCUD],
  data(){
    return {
      myheader: {
        JWTHeaderName: ""
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      tableData:[],
      queryForm:{
        isneedReview:0,
      },
      businessBaseSetting:{

      },
      options: [],
      b2cSystemSalemanSetting:{
        salemanThemeStyle:"#6495ED",
        customerShareText:"",
        mothCashOutDay:"",
        isSalemanNeedReview:true
      },
      b2cSystemCustomerSetting:{
        customerThemeStyle:"#6495ED",
        customerWebTitle:"",
        customerLogo:"",
        customerQrcodeUrl:"",
        customerQq:"",
        customerWechat:"",
        customerTelphone:"",
        shareBackgroundImageUrl:"",
        shareQrcodeUrl:"",
        customerSelfShareText:"",
        promptWithAddTaoText:"",
        customerClientUrl:"",
        customerWelcomeText:"",
        isVerfiyIdcardMakeOrder:false,
        isReciveUseAlipay:false,
        netConnectNumber:"",
        netContentContext:"",
        isCustomerNeedReview:false,
        shareCodeTitleText:"",
        chargeMoneyQrunderText:"",
      },
      b2cSystemOrderSetting:{
        isSalemanMoreCommission:false,
        isCustomerReturnOrCancelOrder:false,
        customerCancelNumbers:0,
        orderTimeLimit:0,
        verifyShopTimeLimit:0,
        browseOrderDetailTimeLimit:0,
        commitOrderTimeLimit:0,
        customerOrderMoneyLimit:0.00,
        cargoReturnMoney:0.00,
        isBusinessReturnNeedReview:false,
        canNotReleaseBusinessOrderPlatefromAry:[],
        canNotReleaseBusinessOrderPlatefrom:"",
        businessAutoSendCargoTime:0,
        taskBusinessAutoConfirmExtenTime:0,
        businessWaitReturnMoneyLimit:0,
        businessAutoConfirmGoodReviewTime:0,
        businessAutoConfirmGoodResetviewTime:0
      },
      b2cSystemSmsSetting:{
        smsRecountTime:0,
        smsVerifyCodeInvalidTime:0
      },
      b2cSystemBackCardSetting:{
        backName:"",
        backCardNum:"",
        backCardName:"",
        backOpenAdress:""
      },
      b2cSystemCashOutSetting:{
        cashOutLimit:0.00,
        cashOutCustomerRemindText:"",
        cashOutBusinessRemindText:"",
        cashOutReviewNumberLimit:0,
        isCashOutLimit:false,
        isOpenPayPassword:false,
        cashOutLtMonty:0.00,
        cashOutRangeDay:0,
        accountMoneyStoreRate:0.00
      },
      b2cSystemVerifyPhoneSetting:{
        verifyPhoneType:0,
        appKey:"",
        appSecret:"",
        verifyUrl:"",
        appPm2:""
      },
      b2cSystemSettleAccountsLimit:{
        accountResetReviewDays:0,
        moneyReturnExtenTime:0,
        commissionReturnExtenTime:0,
        salemanCommissionType:0,
        salemanCommissionBaseMoney:0,
        salemanCommissionFixMoney:0.00,
        businessRecommendRate:0.00,
        moneyReturnBrokerageType:0,
        moneyReturnBrokerageMoneyRate:0.00,
        moneyReturnBrokerageMoney:0.00,
        moneyReturnBrokerageRate:0.00,
        brkerageReturnTimeType:0,
        taobaoUploadImageTypeAry:[],
        jdUploadImageTypeAry:[],
        pddUploadImageTypeAry:[],
        dyUploadImageTypeAry:[],
        customerVerifyConditionAry:[],
        customerFinishOrderShareNumbers:0,
        newCustomerOrderReciveConculate:0,
        businessDayReportOnJiecMode:false
      },
      backgrounds:[
        "#0066FF", "#00CCFF", "#FF3300", "#FF9933", "#45a8e9", "#1F9FFF"
      ],
      reciveOrderLimit:{
        rebackTime:0,
        orderRepeatTime:0,
        newOrderLimit:0,
        newOrderMoney:0.00,
        typeDayLimit:0,
        customerOrderLimit:0,
        orderNotLimitAry:[],
        accountNotReviewAry:[],
        orderNumbersToday:0,
        taoOrdersLimit:0,
        jdOrdersLimit:0,
        dyOrdersLimit:0,
        pddOrdersLimit:0,
        albabaOrdersLimit:0,
        loadingOrdersLimit:0,
        opertionOrdersLimit:0,
        reviewOrdersLimit:0,
        spaceReviewTime:0,
        plateformCommonDay:0,
        plateformCommitLimit:0,
        repurchaseDay:0,
        isAccountRepurchase:0,
        plateformAccountTaoLimit:0,
        plateformAccountJdLimit:0,
        plateformAccountPddLimit:0,
        plateformAccountDyLimit:0,
        plateformAccountAlbabaLimit:0,
        isAppealContinueBalance:0,
        isTurnoffTaoVerify:0,
        isForceVerfy:0,
        isBrowseCustomerLimit:0,
        shopNameShowPositionAry: [],
        needBindPlateform: false,
        accountNeedToBindAry:["京东", "拼多多", "抖音"]
      },
    }
  },
  mounted() {
    getAllOrderLimit().then( res =>{
      if (res.success && res.data != null){
        console.log(res.data)
        this.reciveOrderLimit = res.data;
      }
    });
    this.myheader.JWTHeaderName = getJwtToken();
    this.setSelectColor(this.$refs.colorSelect, "#6495ED");
    queryBusinessSetting().then(res => {
      if (res.success && res.data != null){
        this.businessBaseSetting = res.data;
        this.setSelectColor(this.$refs.colorSelect, this.businessBaseSetting.themeStyle == null?"#6495ED":this.businessBaseSetting.themeStyle);
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    this.setSelectColor(this.$refs.colorSSelect, "#6495ED");
    querySalemanSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemSalemanSetting = res.data;
        this.setSelectColor(this.$refs.colorSSelect, this.b2cSystemSalemanSetting.salemanThemeStyle == null ? "#6495ED":this.b2cSystemSalemanSetting.salemanThemeStyle);
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    this.setSelectColor(this.$refs.colorCSelect, "#6495ED");
    queryCustomeSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemCustomerSetting = res.data;
        this.setSelectColor(this.$refs.colorCSelect, this.b2cSystemCustomerSetting.customerThemeStyle == null?"#6495ED":this.b2cSystemCustomerSetting.customerThemeStyle);
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    queryOrderSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemOrderSetting = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    querySmsSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemSmsSetting = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    queryBackCardSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemBackCardSetting = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    queryCashOutSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemCashOutSetting = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
    queryVerifyPhoneSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemVerifyPhoneSetting = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
    querySettletSetting().then(res => {
      if (res.success && res.data != null){
        this.b2cSystemSettleAccountsLimit = res.data;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods: {
    handleAvatarRemove(file) {
      console.log(file)
    },
    handleB2cAttarchSuccess(obj, res, file) {
      console.log(obj, res, file);
      let urlStr = res.data;
      if (obj.index == 0) {
        this.b2cSystemCustomerSetting.firstImageUrl = urlStr;
      } else if (obj.index == 1) {

        this.b2cSystemCustomerSetting.secondImageUrl = urlStr;
      } else {
        this.b2cSystemCustomerSetting.thirdImageUrl = urlStr;
      }
    },
    handleAvatarLogoSuccess(res, file) {
      console.log(res, file);
      this.businessBaseSetting.businessLogo = res.data;
      console.log(this.businessBaseSetting.businessLogo)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarCLogoSuccess(res, file) {
      console.log(res, file);
      this.b2cSystemCustomerSetting.customerLogo = res.data;
      console.log(this.businessBaseSetting.customerLogo)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarBackSuccess(res, file) {
      console.log(res, file);
      this.businessBaseSetting.businessBackImageUrl = res.data;
      console.log(this.businessBaseSetting.businessBackImageUrl)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarQrcodeSuccess(res, file) {
      console.log(res, file);
      this.businessBaseSetting.qrcodeUrl = res.data;
      console.log(this.businessBaseSetting.qrcodeUrl)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarCQrcodeLogoSuccess(res, file) {
      console.log(res, file);
      this.b2cSystemCustomerSetting.customerQrcodeUrl = res.data;
      console.log(this.b2cSystemCustomerSetting.customerQrcodeUrl)
      let self = this;
      self.$forceUpdate();
    },
    handleShareBackImageSuccess(res, file) {
      console.log(res, file);
      this.b2cSystemCustomerSetting.shareBackgroundImageUrl = res.data;
      console.log(this.b2cSystemCustomerSetting.shareBackgroundImageUrl)
      let self = this;
      self.$forceUpdate();
    },
    //设置颜色选择框中颜色
    setSelectColor(dom, color){
      //通过操作dom节点改变样式
      this.$nextTick(() => {
        if (dom) {
          dom = dom.$el.children[0];
          let inputDom = dom.querySelectorAll(".el-input__inner");
          let icon = dom.querySelectorAll(".el-input__icon");
          inputDom[0].style["background-color"] = color;
          inputDom[0].style["color"] = color;
          icon[0].style["color"] = "black";
        }
      })
    },
    colorChange(val){
      this.setSelectColor(this.$refs.colorSelect, val)
    },
    colorSChange(val){
      this.setSelectColor(this.$refs.colorSSelect, val)
    },
    colorCChange(val){
      this.setSelectColor(this.$refs.colorCSelect, val)
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    tackReviewChange(val){
    },
    saveData(){
      addReplaceOrderLimit(this.reciveOrderLimit).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          getAllOrderLimit().then(res => {
            if (res.success){
              this.reciveOrderLimit = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateBusinessSetting(this.businessBaseSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryBusinessSetting().then(res => {
            if (res.success){
              this.businessBaseSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateSalemanSetting(this.b2cSystemSalemanSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          querySalemanSetting().then(res => {
            if (res.success){
              this.B2cSystemSalemanSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateCustomerSetting(this.b2cSystemCustomerSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryCustomeSetting().then(res => {
            if (res.success){
              this.b2cSystemCustomerSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateOrderSetting(this.b2cSystemOrderSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryOrderSetting().then(res => {
            if (res.success){
              this.b2cSystemOrderSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateSmsSetting(this.b2cSystemSmsSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          querySmsSetting().then(res => {
            if (res.success){
              this.b2cSystemSmsSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateBackCardSetting(this.b2cSystemBackCardSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryBackCardSetting().then(res => {
            if (res.success){
              this.b2cSystemBackCardSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateCashOutSetting(this.b2cSystemCashOutSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryCashOutSetting().then(res => {
            if (res.success){
              this.b2cSystemCashOutSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateVerifyPhoneSetting(this.b2cSystemVerifyPhoneSetting).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          queryVerifyPhoneSetting().then(res => {
            if (res.success){
              this.b2cSystemVerifyPhoneSetting = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

      addOrUpdateSettletSetting(this.b2cSystemSettleAccountsLimit).then( res => {
        if (res.success){
          this.$message({message: res.data, type: 'success'});
          querySettletSetting().then(res => {
            if (res.success){
              this.b2cSystemSettleAccountsLimit = res.data;
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}


.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 180px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}

.avatar {
  width: 180px;
  height: 180px;
  display: block;
}
</style>
